<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app :width="450">
      <Menu></Menu>
      <template v-slot:append v-if="layerIsActive">
        <v-divider></v-divider>
        <v-hover>
          <template v-slot:default="{ hover }">
            <v-card outlined class="pa-4">
              <img :src="legendUrl" class="legend-image"/>
              <v-fade-transition>
                <v-overlay v-if="hover" absolute>
                  <v-icon size="100" @click="dialog.legend = true">mdi-magnify-plus</v-icon>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </template>
        </v-hover>
        <v-dialog v-model="dialog.legend" width="unset">
          <v-card class="pb-5" style="max-width: 1500px">
            <v-card-title width="unset">Legend</v-card-title>
            <div class="pa-5">
              <v-img :src="legendUrl"
                     :contain="true"></v-img>
            </div>
          </v-card>
        </v-dialog>
      </template>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4 hidden-sm-and-down">
        SOIL-DE Viewer
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu open-on-hover close-on-content-click offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon v-if="$vuetify.breakpoint.smAndDown" v-on="on">
            <v-icon>mdi-information-outline</v-icon>
          </v-btn>
          <v-btn v-else text class="mx-5" v-on="on">
            Projekt Informationen
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="dialog.background = true">
            <v-list-item-title>Hintergrund</v-list-item-title>
          </v-list-item>
          <v-list-item @click="dialog.aim = true">
            <v-list-item-title>Ziel</v-list-item-title>
          </v-list-item>
          <v-list-item @click="dialog.partner = true">
            <v-list-item-title>Projektpartner</v-list-item-title>
          </v-list-item>
          <v-list-item @click="dialog.publications = true">
            <v-list-item-title>Publikationen</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-dialog v-model="dialog.background" width="800">
        <Background></Background>
      </v-dialog>
      <v-dialog v-model="dialog.aim" width="800">
        <Aim></Aim>
      </v-dialog>
      <v-dialog v-model="dialog.partner" width="800">
        <Partner></Partner>
      </v-dialog>
      <v-dialog v-model="dialog.publications" width="800">
        <Publications></Publications>
      </v-dialog>
      <a href="https://flf.julius-kuehn.de/soil-de.html">
        <v-img src="@/assets/Logo_SOIL-DE.png" alt="JKI Logo" contain max-height="50px" max-width="60px"/>
      </a>
      <a href="https://www.ble.de/DE/Startseite/startseite_node.html">
        <v-img src="@/assets/logo_ble.png" alt="JKI Logo" contain max-height="50px" max-width="120px"/>
      </a>
    </v-app-bar>
    <v-main>
      <v-container fluid fill-height class="pa-0 ma-0">
        <Map></Map>
      </v-container>
    </v-main>
    <plot-dialog/>
    <plot-time-dialog/>
  </v-app>
</template>

<script>
import Map from "@/components/Map";
import Partner from "@/components/Partner";
import Aim from "../components/Aim";
import Background from "../components/Background";
import Menu from "../components/Menu";
import PlotDialog from "../components/PlotDialog";
import PlotTimeDialog from "../components/PlotTimeDialog";
import {mapGetters} from "vuex";
import Publications from "../Publications.vue";

export default {
  components: {
    Map,
    Partner,
    Aim,
    Menu,
    Background,
    PlotDialog,
    PlotTimeDialog,
    Publications
  },
  props: {
    source: String,
  },
  computed: {
    ...mapGetters("map", ["layerIsActive", "legendUrl"])
  },
  data: () => ({
    dialog: {
      partner: false,
      aim: false,
      background: false,
      legend: false,
      publications: false
    },
    drawer: null,
  }),
}
</script>

<style scoped>
.legend-image {
  max-height: 150px;
  max-width: 100%;
}
</style>


